import { render, staticRenderFns } from "./JqueryCommon.vue?vue&type=template&id=12a52796&"
import script from "./JqueryCommon.vue?vue&type=script&lang=js&"
export * from "./JqueryCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports